import React, { ReactElement } from 'react';
import {Input, FormFeedback} from 'reactstrap';
import './FormInput.scss';

const FormTextInput = (props: any) : ReactElement => {
  const {input, meta, ...inputProps} = props;
  return (
    <div className="redux-form-input">
      <Input
        {...inputProps}
        onChange={input.onChange}
        invalid={meta.error ? true : false}
      />
      <FormFeedback style={{textAlign: 'left'}}>{meta.error}</FormFeedback>
    </div>
  );
};

export default FormTextInput;
